<template>
    <div class="main">
        <c-panel title="ALMOXARIFADO — PRODUTOS" titleIcon="fas fa-boxes">
            <el-form label-position="top">
                <el-row :gutter="10" class="u-mt-10 u-mb-10">
                    <el-col :xs="24" :sm="10">
                        <el-form-item label="Buscar (nome ou código)">
                            <el-input v-model="filtro.busca" placeholder="Pesquisar produto..." @keyup.native.enter="load(1)" clearable @clear="load(1)"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="7">
                        <el-form-item label="Grupo">
                            <el-select v-model="filtro.grupo_id" placeholder="Todos" filterable clearable style="width:100%;" @change="load(1)">
                                <el-option v-for="g in grupos" :key="g.id" :label="g.nome" :value="g.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="7" class="u-text-right" style="padding-top: 30px;">
                        <router-link to="/admin/almox-produto/cadastro" class="btn-new-register">
                            <el-button type="primary">NOVO PRODUTO</el-button>
                        </router-link>
                    </el-col>
                </el-row>
            </el-form>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th class="hidden-mobile" style="width: 70px;">cod</th>
                            <th style="width: 110px;">Código</th>
                            <th>Nome</th>
                            <th class="hidden-mobile">Grupo</th>
                            <th class="hidden-mobile">Subgrupo</th>
                            <th class="hidden-mobile u-text-center" style="width: 70px;">UM</th>
                            <th class="hidden-mobile u-text-center" style="width: 90px;">Situação</th>
                            <th style="width: 200px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="item in items" :key="item.id">
                            <td class="hidden-mobile">{{ item.id }}</td>
                            <td>{{ item.codigo }}</td>
                            <td class="u-uppercase">{{ item.nome }}</td>
                            <td class="hidden-mobile">{{ item.grupo ? item.grupo.nome : '—' }}</td>
                            <td class="hidden-mobile">{{ item.subgrupo ? item.subgrupo.nome : '—' }}</td>
                            <td class="hidden-mobile u-text-center">{{ item.unidade_medida }}</td>
                            <td class="hidden-mobile u-text-center">{{ item.situacao === false ? 'Inativo' : 'Ativo' }}</td>
                            <td class="u-text-center acao">
                                <router-link :to="'/admin/almox-produto/edit/' + item.id" class="link-icon u-mr-10" style="color: rgba(0, 0, 0, 0.87) !important;">
                                    <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
                                </router-link>
                                <el-button @click="abrirUnificar(item)" title="Unificar duplicado" type="warning" icon="el-icon-connection" size="mini" plain></el-button>
                                <el-button class="u-ml-10" @click="excluir(item.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                            </td>
                        </tr>
                        <tr v-if="!items.length">
                            <td colspan="8" class="u-text-center" style="padding: 20px; color: #909399;">Nenhum produto encontrado.</td>
                        </tr>
                    </tbody>
                </table>

                <div v-if="!statusList" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>

                <el-row :gutter="10" v-if="statusList">
                    <el-col :xs="24" :sm="12"><div class="u-text-left u-mt-10">Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros.</div></el-col>
                    <el-col :xs="24" :sm="12" v-if="paginate.qtdItens > 30">
                        <div class="u-text-right">
                            <el-pagination :current-page="paginate.page" class="u-mt-10" :total="paginate.qtdItens" @current-change="load" :page-size="30" background layout="prev, pager, next" small></el-pagination>
                        </div>
                    </el-col>
                </el-row>
            </div>

            <!-- Modal unificação de produto -->
            <el-dialog :close-on-click-modal="false" title="UNIFICAR PRODUTO DUPLICADO" :visible.sync="modalUnificar" width="560px">
                <div v-if="produtoSelecionado">
                    <dl><dt>PRODUTO (será excluído)</dt><dd>{{ produtoSelecionado.codigo }} — {{ produtoSelecionado.nome }}</dd></dl>
                    <el-form label-position="top" class="u-mt-15">
                        <el-form-item label="Cód. do produto que receberá os movimentos">
                            <el-input v-model="produtoDestinoId" v-mask="'##########'" placeholder="Informe o código (id) do produto destino"></el-input>
                        </el-form-item>
                        <i style="color:#909399;">Os movimentos de estoque e itens de pedido do produto duplicado serão transferidos para o produto destino, e o duplicado será excluído.</i>
                    </el-form>
                </div>
                <span slot="footer">
                    <el-button @click="modalUnificar = false">CANCELAR</el-button>
                    <el-button class="u-ml-10" type="primary" @click="confirmarUnificacao">UNIFICAR</el-button>
                </span>
            </el-dialog>
        </c-panel>
    </div>
</template>

<script>
export default {
    data: () => ({
        statusList: false,
        filtro: { busca: '', grupo_id: '' },
        paginate: { page: 1, qtdItens: null, from: '', to: '' },
        items: [],
        grupos: [],
        modalUnificar: false,
        produtoSelecionado: null,
        produtoDestinoId: ''
    }),
    mounted () {
        this.carregarGrupos()
        this.load(1)
    },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        carregarGrupos () {
            this.$axios.get(`${this.baseUrl()}/api/almox-grupo/getAll`, this.$store.getters.getHeaderAuth)
                .then(r => { this.grupos = r.data || [] }).catch(e => this.$store.commit('throwException', e))
        },
        load (page) {
            this.paginate.page = page || 1
            this.statusList = false
            this.items = []
            this.$axios.post(`${this.baseUrl()}/api/almox-produto/getAllPaginate?page=${this.paginate.page}`, this.filtro, this.$store.getters.getHeaderAuth)
                .then(r => {
                    this.items = r.data.data
                    this.paginate.qtdItens = r.data.total
                    this.paginate.from = r.data.from
                    this.paginate.to = r.data.to
                    this.statusList = true
                }).catch(e => { this.statusList = true; this.$store.commit('throwException', e) })
        },
        excluir (id) {
            this.$msgbox.confirm('Tem certeza que deseja excluir este produto?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {
                window.eventBus.$emit('loading', true)
                this.$axios.delete(`${this.baseUrl()}/api/almox-produto/delete/${id}`, this.$store.getters.getHeaderAuth).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' }); return }
                    window.eventBus.$emit('alert', { msg: 'Excluído com sucesso.', type: 'success' })
                    this.load(this.paginate.page)
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            }).catch(() => {})
        },
        abrirUnificar (item) {
            this.produtoSelecionado = item
            this.produtoDestinoId = ''
            this.modalUnificar = true
        },
        confirmarUnificacao () {
            if (!this.produtoDestinoId) { window.eventBus.$emit('alert', { msg: 'Informe o código do produto destino.', type: 'warning' }); return }
            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.baseUrl()}/api/almox-produto/unificar`, { produto_id: this.produtoSelecionado.id, produto_destino_id: this.produtoDestinoId }, this.$store.getters.getHeaderAuth).then(r => {
                window.eventBus.$emit('loading', false)
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' }); return }
                window.eventBus.$emit('alert', { msg: 'Produtos unificados com sucesso.', type: 'success' })
                this.modalUnificar = false
                this.load(this.paginate.page)
            }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        }
    }
}
</script>
